import { Avatar as MuiAvatar, AvatarProps as MuiAvatarProps } from '@mui/material';
import * as React from 'react';

export interface AvatarProps extends MuiAvatarProps {}

export const Avatar = (props: AvatarProps) => {
  return <MuiAvatar {...props} />;
};
